(function () {
  function init(root) {
    if (root.dataset.variantReady) return;
    const select = root.querySelector('[data-variant-select]');
    const data = root.parentElement.querySelector('[data-variant-data]');
    if (!select || !data) return;
    let variants;
    try { variants = JSON.parse(data.textContent); } catch (_) { return; }
    root.dataset.variantReady = 'true';
    const groups = [...root.querySelectorAll('[data-option-index]')];
    const submit = root.querySelector('[data-variant-submit]');
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:root.dataset.currency || 'USD'}).format(cents / 100);
    function update(fromOptions) {
      const choices = groups.map(g => g.querySelector('input:checked')?.value);
      const v = fromOptions ? variants.find(v => v.options.every((x,i) => x === choices[i])) : variants.find(v => String(v.id) === select.value);
      if (!fromOptions && v) groups.forEach((g,i) => g.querySelectorAll('input').forEach(input => input.checked = input.value === v.options[i]));
      groups.forEach(g => {g.querySelector('[data-option-label]').textContent = g.querySelector('input:checked')?.value || '';});
      select.value = v ? String(v.id) : '';
      select.disabled = !v;
      submit.disabled = !v?.available;
      submit.textContent = !v ? 'Unavailable' : v.available ? submit.dataset.addLabel : 'Sold out';
      root.querySelector('[data-variant-price]').textContent = v ? money(v.price) : 'Unavailable';
      const compare = root.querySelector('[data-variant-compare]');
      compare.hidden = !v || !(v.compare_at_price > v.price);
      compare.textContent = compare.hidden ? '' : money(v.compare_at_price);
      const sku = root.querySelector('[data-variant-sku]');
      if(sku) {sku.textContent = v?.sku || '';sku.hidden = !v?.sku;}
      const stock = root.querySelector('.wo-stock');
      if(stock) stock.hidden = !v?.available || !v?.requires_shipping;
      const shipping = root.querySelector('[data-shipping-details]');
      if(shipping) shipping.hidden = !v?.requires_shipping;
      const media = v?.featured_media?.id || v?.featured_image?.id;
      const chosen = media && root.querySelector(`[data-media-id="${media}"]`);
      if(chosen) root.querySelector('.wo-product-media').prepend(chosen.closest('a'));
      const url = new URL(location.href);
      if(v) url.searchParams.set('variant',v.id); else url.searchParams.delete('variant');
      history.replaceState({},'',url);
    }
    groups.forEach(g => g.addEventListener('change',()=>update(true)));
    select.addEventListener('change',()=>update(false));
    root.querySelector('form').addEventListener('submit',e => {if(submit.disabled || !select.value) e.preventDefault();});
    select.hidden = true;
    update(false);
  }
  document.querySelectorAll('[data-product-section]').forEach(init);
  if(!window.wagpureVariantsBound) {
    document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-product-section]').forEach(init));
    window.wagpureVariantsBound=true;
  }
})();
